import {
  IAutoComplianceRequest,
  IAutoComplianceStatus,
  ICarbonClearGovernanceRequest,
} from "../contracts/AutoCompliance";
import { CarbonClearGovEnum } from "../enums/AutoCompliance";
import { postDataAsync } from "../ZeosApiExecutor";
import { IAutoCompliance } from "./interfaces/IAutoCompliance";

const BASE_URL = `/AutoCompliance`;

export const AutoCompliance: IAutoCompliance = {
  checkGovernance: async (request: IAutoComplianceRequest) => {
    return await postDataAsync<IAutoComplianceStatus>(
      `${BASE_URL}/CheckGovernance`,
      request
    );
  },
  carbonClearGovernance: async (request: ICarbonClearGovernanceRequest) => {
    return await postDataAsync<CarbonClearGovEnum>(
      `${BASE_URL}/CarbonClearGovernance`,
      request
    );
  },
};
